import { registerBlockType } from '@wordpress/blocks';
import './style.scss';
import Edit from './edit';

registerBlockType( 'create-block/domain-for-sale-template', {
	edit: Edit,
	save: () => null,
} );
